import type { Route } from 'next';
import Link, { type LinkProps } from 'next/link';

import { buttonClassName, type ButtonStyleProps } from './button';

export type ButtonLinkProps<T extends string = string> = Omit<LinkProps<T>, 'href'> &
  ButtonStyleProps & { href: Route<T> };

export function ButtonLink<T extends string>({
  href,
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  ...props
}: ButtonLinkProps<T>) {
  return (
    <Link
      {...props}
      href={href}
      className={buttonClassName({ fullWidth }, className)}
      data-variant={variant}
      data-size={size}
    />
  );
}
